import { useContext } from "react";
import LoaderContext from "../../../Components/loader";
import { ErrorMessage, Form, Formik } from "formik";
import SidebarField from "../../../Components/SidebarField";
import Button from "../../../Components/Button";
import { FormField } from "../../../Components/FormField";
import TextInput from "../../../Components/TextInput";
import ToggleField from "../../../Components/ToggleField";
import { toast } from "react-toastify";
import {
  approvalStatusApi,
} from "../../../App/api/multilevelApproval.api";
import ApprovalStatus from "../ApprovalStatus";
import ApprovalFlowManager from "../ApprovalFlowManager";

export const SubCategoryForm = ({
  initialValues,
  handleClose,
  selectedOrder,
  user,
  getAllSubcategory,
  actionData,
  approvalStatus,
  setActionData,
}) => {
  const { handleLoading } = useContext(LoaderContext);

  const {
    approvalLevel,
    ApprovalFlow,
    matchedData,
    waitingForApproval,
    allApprovals,
    validateAndApprove
  } = ApprovalFlowManager({
    component: "SubCategory", 
    currentItems:selectedOrder,
    approvalStatus,
  });
console.log("waitingForApproval:",waitingForApproval)
  const canApprove = waitingForApproval?.some((item) => item?.user === user.first_name);
 console.log("canApprove:",canApprove)
   const matchedApproval = waitingForApproval?.find(
  (item) => item?.user === user?.first_name
);

  const handleSubmit = async () => {
    handleLoading(true);
    try {
      const payload = {
        component_id: selectedOrder?._id,
        component: "SubCategory",
        approvalFlow: allApprovals?.data?.[0]?._id,
        progress: {
          level: matchedApproval?.level,
          user: user._id,
          status: actionData,
          remarks: "",
        },
      };

      if (!validateAndApprove(payload)) {
        handleLoading(false);
        return;
      }
      ApprovalFlow?.length > 0
        ? await approvalStatusApi.updateApprovalStatus(
            payload,
            ApprovalFlow?.[0]?._id
          )
        : await approvalStatusApi.createApprovalStatus(payload);

      toast.success(`Subcategory ${actionData} by ${approvalLevel?.level}!`);
      getAllSubcategory();
      setActionData(null);
    } catch (error) {
      toast.error(error?.message);
    } finally {
      handleLoading(false);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ handleChange, values }) => (
        <Form>
          <SidebarField
            button1={
              <Button text="Cancel" type="button" onClick={handleClose} />
            }
            button2={
              <Button
                disable={
                      ApprovalFlow?.[0]?.progress?.status === "Approved" ||
                      !canApprove
                        ? "disabled"
                        : ""
                    }
                text={
                  ApprovalFlow?.[0]?.progress?.status === "Approved"
                    ? "Approved"
                    : "Approve"
                }
                type="submit"
              />
            }
            handleClose={handleClose}
            title="Approve Subcategory"
          >
            <div className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <FormField label="Sub Category Name" tooltip="Enter subcategory">
                <TextInput
                  name="name"
                  type="text"
                  placeholder="Sub Category Name"
                  onChange={handleChange}
                  required={true}
                  className="outline-none"
                  value={selectedOrder?.name}
                  readOnly
                />
                <ErrorMessage name="name" component="div" className="error" />
              </FormField>

              <FormField label="Category" tooltip="Choose or create a category">
                <div className="flex items-center gap-2">
                  <TextInput
                    name="category"
                    type="text"
                    onChange={handleChange}
                    required={true}
                    className="outline-none"
                    readOnly
                    value={selectedOrder?.Category.name}
                  />
                </div>
                <ErrorMessage
                  name="category"
                  component="div"
                  className="error"
                />
              </FormField>

              <FormField
                label="Sequence Number"
                tooltip="Enter sequence number to sort the subcategory"
              >
                <TextInput
                  name="sequence"
                  type="number"
                  placeholder="Sequence Number"
                  onChange={handleChange}
                  required={true}
                  className="outline-none"
                  readOnly
                  value={values.sequence}
                />
                <ErrorMessage name="number" component="div" className="error" />
              </FormField>
              <ToggleField
                text="Is subcategory visible to user?"
                name="is_visible"
                onChange={handleChange}
                value={selectedOrder?.is_visible}
                readOnly
              />

              <ApprovalStatus
                matchedData={matchedData}
                waitingForApproval={waitingForApproval}
              />
            </div>
          </SidebarField>
        </Form>
      )}
    </Formik>
  );
};
